export default "__VITE_ASSET__BP0rRU9S__"